(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nv-color-context"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nv-color-context')) {
    customElements.define('nv-color-context', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info');
        if (!this.scope) return;
        this.controller = new AbortController();
        this.scope.addEventListener('change', (event) => {
          if (!event.target.closest('variant-selects')) return;
          const picker = this.scope.querySelector('variant-selects');
          const selected = picker?.querySelector('input[type="radio"]:checked') || picker?.querySelector('select');
          if (!selected) return;
          this.querySelectorAll('[data-color-sample]').forEach((sample) => {
            sample.hidden = sample.dataset.colorSample !== selected.value;
          });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nv-mobile-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
    const support = document.querySelector('.nv-mobile-shopping-support');
    if (!support) return;
    const purchaseArea = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('#MainContent');
    if (!purchaseArea || !('IntersectionObserver' in window)) return;
    let purchaseVisible = true;
    const update = () => {
      const viewport = window.visualViewport;
      const keyboardOpen = viewport && window.innerHeight - viewport.height > 120;
      document.body.classList.toggle('nv-mobile-help-available', !purchaseVisible && !keyboardOpen);
    };
    const observer = new IntersectionObserver(([entry]) => {
      purchaseVisible = entry.isIntersecting;
      update();
    }, { rootMargin: '64px 0px' });
    observer.observe(purchaseArea);
    window.visualViewport?.addEventListener('resize', update, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nv-order-reassurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const badge = event.target.closest('.nv-order-reassurance .jdgm-preview-badge');
    if (!badge) return;
    const details = badge.closest('.nv-order-reassurance').querySelector('details');
    if (details) details.open = true;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nv-proof-choice"] && !Shopify.designMode) return;
  try {
    function nvRequireProofChoice(event) {
    const button = event.target.closest && event.target.closest('button[type="submit"], input[type="submit"]');
    const form = event.type === 'submit' ? event.target : button && button.form;
    const choice = form && form.querySelector('[data-nv-proof]');
    if (choice && !choice.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      choice.reportValidity();
    }
  }
  window.addEventListener('click', nvRequireProofChoice, true);
  window.addEventListener('submit', nvRequireProofChoice, true);
  } catch(e) { console.error(e); }
})();

})();
